import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Container, Grid } from "@material-ui/core";
import { Avatar } from "@progress/kendo-react-layout";
import { Link } from "react-router-dom";
import { Tooltip } from "@progress/kendo-react-tooltip";
import { Label } from "@progress/kendo-react-labels";
import {
  SimpleLoading,
  InformationADAkubicaFirmaDigitalInvitedPure,
  DialogTermsCond,
  PromotionalFooterPure,
  HeaderHLPure,
} from "../../pures";
import DialogUpdateUserAddress from "../../pures/dialog-update-user-address/dialog-update-user-address";
import SignatureCredetialForm from "../../views/signature-credetial-form/SignatureCredetialForm";
import {
  SignDigitalAutograph,
  SignDigitalAvanced,
} from "../../../assets/logos/icons";
// import AutografaIcon from "../../../assets/logos/icons/Grupo_527@2x.png";
import FiableIconWhite from "../../../assets/logos/icons/Grupo_561.png";
import AutografaIconWhite from "../../../assets/logos/icons/Grupo_562.png";
import "./profile.css";
import "./tooltip.css";

const TooltipContentTemplate = ({
  title,
  content,
  subContent,
  restContent,
}) => (
  <a style={{ width: "100% !importat" }}>
    <strong>{title}</strong>
    <p style={{ width: "100%" }}>{content}</p>
    <p style={{ width: "100%" }}>{subContent}</p>
    <p style={{ width: "100%" }}>{restContent}</p>
  </a>
);
const ProfileView = (props) => {
  const [open, setOpen] = useState(false);
  const { t } = useTranslation();
  const [modalTermsCond, setModalTermsCond] = useState(null);
  const handleOnChangeTooltip = () => setOpen(!open);
  const hiddeTooltip = () => setOpen(true);
  const openModalTermsCond = (value) => setModalTermsCond(value);
  const [visibleSignatureReliable, setVisibleSignatureReliable] =
    useState(false);
  const [visibleSignatureAutograph, setVisibleSignatureAutograph] =
    useState(false);
  const toggleSignatureReliable = () => {
    setVisibleSignatureReliable(!visibleSignatureReliable);
  };
  const toggleSignatureAutograph = () => {
    setVisibleSignatureAutograph(!visibleSignatureAutograph);
  };

  return (
    <div className="profileView-container-profile">
      {props.loading ? (
        <SimpleLoading />
      ) : (
        <>
          {/* Container profile image */}
          <div
            className="profile-image"
          // style={{ display: "grid" }}
          >
            <Avatar
              shape="circle"
              type="image"
              className="profile-container-img"
            >
              <img
                src={props.userPathImage}
                alt="user image"
                className="k-avatar-image profile-img imageSizesStyles"
              />
            </Avatar>
            <div
              className="custom-input-file-p imageButton"
              xs={8}
              lg={8}
              md={8}
              sm={8}
              es={8}
            >
              <input
                className="input-file-p"
                type="file"
                accept="image/*"
                id="file"
                onClick={(e) => (e.target.value = null)}
                onChange={(e) => {
                  props.handleImage(e);
                }}
              />
              {t("dialogUpdateUserAddress.tooltipButtonImageEdit")}
            </div>
          </div>

          <Container
            fixed
            xs={12}
            lg={12}
            md={12}
            sm={12}
            es={12}
            className={"profileView-box"}
          >
            {/* Container title profile */}
            <Grid
              xs={12}
              lg={12}
              md={12}
              sm={12}
              es={12}
              className='header-inbox'>
              <HeaderHLPure title={t("profileView2.titleProfile")} />
            </Grid>
            {/* Container of profile information */}
            <div className="profileView-informationLayer">
              <div className="profileView-layer-border-box">
                {/* Information of the User */}
                <Grid
                  container
                  xs={12}
                  lg={12}
                  md={12}
                  sm={12}
                  es={12}
                  spacing={12}
                  className={"profileView-gridContainerInformationStyles"}
                >
                  {props.personTypeId === 2 ? (
                    <>
                      <Grid
                        item
                        xs={12}
                        lg={6}
                        md={6}
                        sm={6}
                        es={6}
                        className="profileView-container-info"
                      >
                        <p className="profile-layer-label">
                          {t("profileView2.information.organization")}
                        </p>
                      </Grid>
                      <Grid
                        item
                        xs={12}
                        lg={6}
                        md={6}
                        sm={6}
                        es={6}
                      >
                        <p className="profileView-label-b">
                          {props.organization || ""}
                        </p>
                      </Grid>
                    </>
                  ) : null}

                  <Grid
                    item
                    xs={12}
                    lg={6}
                    md={6}
                    sm={6}
                    es={6}
                    className="profileView-container-info"
                  >
                    <p className="profileView-layer-label">
                      {t("profileView2.information.name")}
                    </p>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    lg={6}
                    md={6}
                    sm={6}
                    es={6}
                    className="profileView-container-info"
                  >
                    <p className="profileView-label-b">
                      {props.userFullName || ""}
                    </p>
                  </Grid>

                  <Grid
                    item
                    xs={12}
                    lg={6}
                    md={6}
                    sm={6}
                    es={6}
                    className="profileView-container-info"
                  >
                    <p className="profileView-layer-label">
                      {t("registerUserInvited.formLabelCellPhoneNumber2")}
                    </p>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    lg={6}
                    md={6}
                    sm={6}
                    es={6}
                    className="phone"
                  >
                    <p className="profileView-label-b">
                      {props.cellphoneNumber}
                    </p>
                  </Grid>

                  <Grid
                    item
                    xs={12}
                    lg={6}
                    md={6}
                    sm={6}
                    es={6}
                    className="profileView-container-info"
                  >
                    <p className="profileView-layer-label">
                      {t("profileView2.information.email")}
                    </p>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    lg={6}
                    md={6}
                    sm={6}
                    es={6}
                  >
                    <p className="profileView-label-b">
                      {props.userMail || ""}
                    </p>
                  </Grid>

                  {props.userTypeId !== 3 &&
                    props.userFullDirection !==
                    "-, Col. -, -, -, C.P. 00000 -" && (
                      <>
                        <Grid
                          item
                          xs={12}
                          lg={6}
                          md={6}
                          sm={6}
                          es={6}
                          className="profileView-container-info"
                        >
                          <p className="profileView-layer-label">
                            {t("profileView2.information.address")}
                          </p>
                        </Grid>
                        {/* {(props.userTypeId !== 3 && props.userFullDirection !== "-, Col. -, -, -, C.P. 00000 -") && */}
                        <Grid
                          item
                          xs={12}
                          lg={3}
                          md={4}
                          sm={6}
                          es={3}
                          className="profileView-container-info"
                        >
                          <p className="profileView-label-b">
                            {props.userFullDirection || ""}
                          </p>
                        </Grid>
                      </>
                    )}

                  <Grid
                    item
                    xs={12}
                    lg={6}
                    md={6}
                    sm={6}
                    es={6}
                    className="profileView-container-info"
                  >
                    {/* <Tooltip
                      openDelay={600}
                      position="top"
                      anchorElement="target"
                      tooltipClassName="tooltipGeneralStyle"
                    > */}
                    {/* <div className="profileView-btn-container-password">
                      <button
                        title={t("profileView2.information.changePassword")}
                        className="profileView-btn-password"
                        onClick={props.goToChangePasswordScreen}
                      //   style={{ marginTop: "8px" }}
                      >
                        {t("profileView2.information.changePassword")}
                      </button>
                    </div> */}
                    {/* </Tooltip> */}
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    lg={6}
                    md={6}
                    sm={6}
                    es={6}
                    className="profileView-container-info"
                  >
                    <DialogUpdateUserAddress
                      {...props}
                      handleChangeGeneral={props.handleChangeGeneral}
                      handleChangeCellPhone={props.handleChangeCellPhone}
                      handleChangePhone={props.handleChangePhone}

                      toggleDialogUpdateUserAddress={
                        props.toggleDialogUpdateUserAddress
                      }
                      onSubmitUpdateUserAddress={
                        props.onSubmitUpdateUserAddress
                      }
                      notification={props.notification}
                      onCloseOpenModal={props.onCloseOpenModal}
                      toggleLoadingRequesting={
                        props.toggleLoadingRequesting
                      }
                      toggleCompletedRequesting={
                        props.toggleCompletedRequesting
                      }
                      toggleErrorRequesting={props.toggleErrorRequesting}
                    />
                    <button
                      title={t("profileView2.information.changePassword")}
                      className="profileView-btn-password"
                      onClick={props.goToChangePasswordScreen}
                    >
                      {t("profileView2.information.changePassword")}
                    </button>
                  </Grid>
                </Grid>

                <div>
                  <Tooltip
                    position="right"
                    open={true}
                    anchorElement="target"
                    content={(props) => (
                      <TooltipContentTemplate
                        title={"Tipo de firmas"}
                        content={
                          "Acorde a las características de tus operaciones, puedes utilizar la Firma Autógrafa Digital o la Firma Digital Avanzada. "
                        }
                        subContent={
                          "Para mayor seguridad y certeza jurídica, nuestra Firma Autógrafa Digital incorpora recomendaciones de un perito en grafoscopía, grafología y documentos cuestionados. Para establecer la firma base deberás proporcionar tu identificación y establecer tu firma base dando clic en el botón de Firma Autógrafa Digital Base. "
                        }
                        restContent={
                          "La Firma Digital Avanzada generada desde nuestra plataforma también es fiable, ya que el sistema permite demostrar que los datos con los que creamos la firma corresponden exclusivamente a los firmantes y que dichos datos se encontraban bajo su control exclusivo; por consecuencia, podemos detectar cualquier alteración de la firma o del documento firmado. Da clic en el botón de Firma Digital Avanzada, complementa la información y descarga tus llaves."
                        }
                      />
                    )}
                  >
                    <Label className="profileView-labels">
                      {"Firmas"}
                      <i
                        className="k-icon k-i-information iconTooltipStyles"
                        title={t("signatureRequestView2.tooltipClic")}
                        onClick={() => handleOnChangeTooltip()}
                        onMouseOut={() => hiddeTooltip()}
                      />
                    </Label>
                  </Tooltip>
                  <div className="signature-text">
                    <p className="text-processSignatureProfile">
                      {t("profileView.signatureProfile")}
                    </p>
                    {/* <span className="link-terms-and-conditions-profile" onClick={() => { openModalTermsCond(true) }}>{t('promotionalFooterPure.terms&Conditions')}</span> */}
                  </div>
                  <div className="cards-section">
                    {/* <Link to={{ pathname: `/configuration-signature-history`, state: { item: this.props.dataItem } }}> */}

                    <Link
                      to={{
                        pathname: "/request-reliable-signature",
                        state: { item: props },
                      }}
                    // {...props}

                    //  to={{
                    //     pathname: `/request-reliable-signature/${this.props.dataItem.id}/index` ,
                    //     query:{dataItem: this.props.dataItem}
                    //  }}
                    >
                      <button className="profileView-wrapper-f " {...props}>
                        {/* <div className="profile-wrapper-f card-btn" onClick={toggleSignatureReliable} > */}
                        {/* <img
                        className="pluma"
                        src={FiableIconWhite}
                        style={{
                          width: "39.500px",
                          height: "39.500px",
                          marginTop: "12px",
                          marginBottom: "12px",
                        }}
                      /> */}
                        <img
                          className="pluma-hove"
                          src={SignDigitalAvanced}
                        // style={
                        //   {
                        //       width: "39.500px",
                        //       height: "39.500px",
                        //       marginTop: "12px",
                        //       marginBottom: "12px",
                        //   }
                        // }
                        />
                        {/* <img className='pluma-hove' src={FiableIcon} /> */}
                        {t("profileView.btnDigitalAdvancedSignature")}
                      </button>
                    </Link>
                    <button
                      className="profileView-wrapper-f "
                      onClick={toggleSignatureAutograph}
                    >
                      {/* <img
                      className="pluma"
                      src={AutografaIconWhite}
                      style={{
                        width: "36px",
                        height: "34.500px",
                        marginTop: "12px",
                        marginBottom: "12px",
                      }}
                    /> */}
                      <img
                        className="pluma-hove"
                        src={SignDigitalAutograph}
                      //   style={
                      //     {
                      //       width: "36px",
                      //       height: "34.500px",
                      //       marginTop: "12px",
                      //       marginBottom: "12px",
                      //     }
                      //   }
                      />
                      {t("profileView.btnAuthographSignature")}
                    </button>
                  </div>
                </div>
                {props.userTypeId !==
                  Number(process.env.REACT_APP_USER_TYPE_COLABORADOR) &&
                  props.contractPlanExist}
                {/* Information of Contact and Plan */}
                {props.userTypeId !==
                  Number(process.env.REACT_APP_USER_TYPE_INVITADO) &&
                  props.contractPlanExist ? (
                  <div>
                    {props.userTypeId ===
                      Number(process.env.REACT_APP_USER_TYPE_ADMINISTRADOR) ? (
                      <PromotionalFooterPure />
                    ) : (
                      <PromotionalFooterPure />
                    )}
                  </div>
                ) : (
                  props.contractPlanExist && (
                    <Grid container xs={12} lg={12} md={12} sm={12} es={12}>
                      <InformationADAkubicaFirmaDigitalInvitedPure
                        onInvitedRedirectRegister={
                          props.onInvitedRedirectRegister
                        }
                      />
                    </Grid>
                  )
                )}
              </div>
            </div>
          </Container>
        </>
      )}
      <DialogTermsCond
        modalTermsCond={modalTermsCond}
        openModalTermsCond={openModalTermsCond}
      />

      {/* {visibleSignatureReliable && (
                <Dialog title={props.downloadLoading || props.downloadSuccess || props.downloadErrorMessage ? 'hibou.legal' : "Descarga la firma electrónica fiable"} onClose={toggleSignatureReliable}>
                    {props.downloadSuccess ? (
                        <div className='download-loading' >
                            <img src={Done} />
                            <p style={{ textAlign: 'center' }} >{t('dialogSignRequestPure.requestSucces')}</p>
                        </div>
                    ) : (
                        <>
                            {props.downloadLoading && !props.downloadErrorMessage && (
                                <div className='download-loading' >
                                    <SimpleLoading></SimpleLoading>
                                    <p style={{ textAlign: 'center' }} >{t('dialogSignRequestPure.titleExecutingRequest')}</p>
                                </div>
                            )}
                            {!props.downloadLoading && !props.downloadErrorMessage && (
                                <>
                                    <SignaturesDownload isModal >
                                        {props.children({ setVisibleSignatureReliable })}
                                    </SignaturesDownload>
                                </>
                            )}
                            {props.downloadErrorMessage && (
                                <div className='download-loading' >
                                    <img src={Cancel} />
                                    <p style={{ textAlign: 'center' }} >{t('dialogSignRequestPure.titleErrorRequesting')}</p>
                                </div>
                            )}
                        </>
                    )}
                </Dialog>
            )} */}
      {visibleSignatureAutograph && (
        <SignatureCredetialForm
          onClose={toggleSignatureAutograph}
          changeSignatureUserStates={props.changeSignatureUserStates}
          isLoadingUserDocSupp={props.isLoadingUserDocSupp}
          errorUserDocSupp={props.errorUserDocSupp}
          errorWarningDoc={props.errorWarningDoc}
          signatureImg={props.signatureImg}
          ineFrontImg={props.ineFrontImg}
          ineBackImg={props.ineBackImg}
          changeUserDocSupps={props.changeUserDocSupps}
          toggleErrorUserDocRequesting={props.toggleErrorUserDocRequesting}
          sendUserDocSupps={props.sendUserDocSupps}
          firstName={props.firstName}
          lastName={props.lastName}
          saveImagesSuccess={props.saveImagesSuccess}
          t={t}
          onErrorTimeStamp={props.onErrorTimeStamp}
        >
          <>
            <Label className="profileView-layer-label-step">
              {"CAPTURA DE FIRMA"}
            </Label>
            <p className="text-processSignature">{"Paso 2 de 2"}</p>
          </>
        </SignatureCredetialForm>
      )}
      <DialogTermsCond
        modalTermsCond={modalTermsCond}
        openModalTermsCond={openModalTermsCond}
      />
    </div>
  );
};
export { ProfileView as default };
